import { GetString } from 'fluent-react';
import React from 'react';
import styled from 'styled-components';
import {
  placeholderBorderRadius,
  placeholderPadding,
} from '../graphControlDropdown';
import { primaryColor1 } from '../Utils';

const Link = styled.a`
  cursor: pointer;
  line-height: 1.5;
  color: ${primaryColor1};
`;

const Button = styled(Link)`
  font-size: 1rem;
  border-radius: ${placeholderBorderRadius};
  padding: ${placeholderPadding};
  background: white;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${primaryColor1};
    color: white;
  }

  @media (max-width: 1010px) {
    font-size: 0.8rem;
  }
`;

const BackArrow = styled.span`
  font-size: 2rem;
  position: relative;
  top: 0.4rem;
`;

const FlowChartClosedContainer = styled.div`
  grid-column: 4;

  @media (max-width: 900px) {
    grid-column: 1 / span 4;
    align-self: flex-start;
    margin-top: 0.75rem;
  }
`;

const FlowChartOpenContainer = styled.div`
  grid-column: 1 / span 4;
`;

interface Props {
  getFluentString: GetString;
  policyRecommendationString: string;
  flowChartOpen: boolean;
  showFlowChart: () => void;
  hideFlowChart: () => void;
}

const ToggleButton = (props: Props) => {
  const {
    getFluentString, policyRecommendationString,
    flowChartOpen, showFlowChart, hideFlowChart,
  } = props;

  if (flowChartOpen === false) {
    return (
      <FlowChartClosedContainer>
        <Button onClick={showFlowChart}>
          {getFluentString('rock-song-flow-chart-toggle-button-open', {
            'policy-recommendation': policyRecommendationString,
          })}
        </Button>
      </FlowChartClosedContainer>
    );
  } else {
    return (
      <FlowChartOpenContainer>
        <Link onClick={hideFlowChart}>
          <BackArrow>←</BackArrow>
          {getFluentString('rock-song-flow-chart-toggle-button-close')}
        </Link>
      </FlowChartOpenContainer>
    );
  }
};

export default ToggleButton;
